import * as time from "./time";

/**
 * [Returns an SVG graph of a tag's duration data]
 * @param  {[type]} tag [ tag name string or tagObj ]
 * @return {[type]}     [description]
 */
export function HTML_SVG_Graph(tag, dates = tag.datesSinceFirstTag, unit = "h") {
  // console.log(dates)

  // set up data

  let dataX = dates.map((date) => date[1].summary[tag.name] || 0);
  let dataY = dates.map((date) => `${time.dateFormatter(date[0], "md")}`);

  let padding = 20; // was CSS.z7
  let highest_value = Math.max(...dataX);
  let hours = highest_value / 60; // 60 is for minutes

  // add an extra hour to the scale if it's closer to the next hour (>.5)
  // let hours_grid = Math.round(hours) == Math.ceil(hours)
  //   ? Math.ceil(hours) // if they match, it rounds up >.5, so add an extra hour
  //   : Math.ceil(hours)       // else just round it up

  const hours_grid = Math.ceil(hours);

  // Shorten the grid + font size if there are entries over 10h
  let svg_unit = 25;
  let unitX_px = dates.length > 120 ? 12 : svg_unit;
  dates.length > 60 ? svg_unit * 0.75 : svg_unit * 2.5;

  let unitY_px = 12; //hours        > 10 ? svg_unit * .65 : 12
  let font_size = hours > 10 ? 11 : 12;

  // window calling the SVG function can tell it how big its container is
  // then it can divide by number of dates to see how wide the cells should be
  let width_px = dataX.length * unitX_px;
  let height_px = hours_grid * unitY_px; //range from highest to lowest value in dataX.

  // console.log(tag)
  // console.log(tag.date_first)
  // console.log({dates})

  // console.log(dataX.length)
  // console.log({width_px})
  // console.log({unitX_px})

  // console.log({dataX})
  // console.log({dataY})
  // console.log({hours})
  // console.log({hours_grid})
  // console.log({width_px})
  // console.log({height_px})

  let grid = graph_grid(width_px, height_px, dataX.length - 1, height_px / unitY_px, unitX_px, unitY_px, "horizontal");
  let line = graph_line(width_px, height_px, dataX.length, height_px / unitY_px, dataX, 60, "horizontal");

  let svg_data = {
    rows: {
      units: "mins",
      data: dataY,
    },
    cols: {
      units: "dates",
      data: dataX,
    },
    data: {
      practice: dataX,
      target: [],
    },
    width: width_px,
    height: height_px,
    grid: grid,
    lines: [line],
    unitX: unitX_px,
    unitY: unitY_px,
    padding: padding,
    gutter: function () {
      return `<p>wow</p>`;
    },
  };

  // Build graph sidebar
  let sidebar = `<span>0</span>`;
  for (let x = 1; x <= hours_grid; x++) {
    sidebar = `<span>${x}${unit}</span>` + sidebar;
  }

  // Build graph gutter
  // for each day in dataX, print out an html date
  // depending on the length of X, we will omit certain print-outs
  // hopefully spacing can be accomplished entirely in CSS automatically.
  let gutter = "";

  // for longer than 90 days, we print out months without individual days
  if (dataY.length >= 90) {
    gutter = dates
      .map((x) => {
        let date_span = "";

        if (new Date(x[0]).getDate() == 1) {
          // 1st of month

          const monthNum = new Date(x[0]).getMonth();
          let monthName = window.ui.monthNamesShort[monthNum];

          // If Jan, we print out the year number also
          if (monthNum === 0) {
            monthName += ` ${new Date(x[0]).getFullYear()}`;
          }

          date_span = `<span type="month">${monthName}</span>`;
        } else if (new Date(x[0]).getDay() == 1) {
          // monday
          date_span = `<span type="week">w ${time.compareTwoDatesExcludingTime(new Date(x[0]))}</span>`;
        }
        return date_span; //+=`<span type="day">${new Date(x[0]).getDate()}</span>`
      })
      .join("");
  } else {
    // otherwise we print out individdual days
    gutter = dates.map((x) => {
      return `<span type="day">${new Date(x[0]).getDate()}</span>`;
    });
    gutter[0] = `<span type="day">${new Date(dates[0][0]).getDate()}</span>`;
    gutter = gutter.join("");
  }

  let dataY_length = dataY.length < 90 ? "lo" : dataY.length < 180 ? "mi" : "hi";

  // make a general SVG function that prints any kind of graph
  return `
    <div class="container-outer" days_length="${dataY_length}">
      <div
        class="y-axis units"
        style="padding-top: ${padding / 2}px; line-height: ${unitY_px}px; font-size:${font_size}px;">
        ${sidebar}
      </div>
      <div class="container-inner">
        ${printSVGinHTML(svg_data)}
        <div class="x-axis units" style="width:${svg_data.width}px; padding:0 /*${svg_data.padding}px*/">
          ${gutter}
        </div>
      </div>
    </div>
    `;
}

function printSVGinHTML(data) {
  // let lines = data.lines.map(line=>svg.graph_line(line))
  // console.log(data)
  return `
    <svg
      width="${data.width}"
      height="${data.height}"

      style="margin: 20px auto 10px;"
      >
      <g class="grid">
        <defs>
          <linearGradient
            id="target_gradient" x1="50%" y1="100%" x2="50%" y2="0%"
            gradientUnits="userSpaceOnUse">
            <stop offset="0%" stop-color="var(--svg_grid_colour)" />
          </linearGradient>
        </defs>
        ${data.grid}
      </g>
      <g class="lines">
        <circle ${data.lines[0].first_point} r="2" fill="url('#target_gradient')" />
        <path
          d="${data.lines[0].line}"
          fill="none" stroke="var(--svg_stroke_colour)" stroke-width="var(--svg_stroke_width)" stroke-linecap="round"
        />
      </g>
    </svg>
    `;
}

export function graph_grid(
  graphWidth,
  graphHeight,
  number_of_cols,
  number_of_rows,
  col_width,
  row_height,
  vertical_or_horizontal = "horizontal",
) {
  let colBars = "";
  let rowBars = "";
  let cols = number_of_cols;
  let rows = number_of_rows;
  let x = graphWidth / cols;
  let y = row_height || graphHeight / rows;

  let width = graphWidth;
  let height = graphHeight;

  // console.log({col_width})
  // console.log({x})
  // console.log({width})
  // console.log({graphWidth})
  // console.log({number_of_cols})

  if (vertical_or_horizontal == "vertical") {
    height = graphWidth;
    width = graphHeight;
    cols = number_of_rows;
    rows = number_of_cols;
  }

  // Make Cols
  for (let col = 0; col <= cols; col++) {
    // console.log(x*col)
    colBars += `
      <line x1=${x * col} y1=0 x2=${x * col} y2=${height} stroke="var(--graphLight1)" stroke-dasharray="2" />
    `;
  }

  // Make Rows
  for (let row = 0; row <= rows; row++) {
    rowBars += `
      <line x1=0 y1="${y * row}" x2=${width} y2="${y * row}" stroke="var(--graphLight1)" stroke-dasharray="2" />
    `;
  }

  let graph = `
    <g class="grid-x">${colBars}</g>
    <g class="grid-y">${rowBars}</g>
    `;
  return graph || "";
}

export function graph_line(
  graphWidth,
  graphHeight,
  X_bars,
  Y_bars,
  data,
  unitX,
  unitY,
  vertical_or_horizontal = "horizontal",
) {
  let target;
  let goal;

  let x = graphWidth / X_bars;

  // distribute a single bar among the widths of the rest of the bars
  x = x + x / X_bars;

  let y = graphHeight / Y_bars;
  let graph_flip = function (x) {
    return x * -1 + graphHeight;
  }; // because SVG coordinates start top-left not bottom left

  let x_increment = 0 - x; //(x - (x / 2) ) * -1 // offset the first item by half of itself, negatively.
  let y_increment = 0;

  let svgPath = ""; // `M${x} ${y}`
  let firstPoint = "";

  // console.log('----------')
  // console.log(data)

  // Make the SVG Line
  if (vertical_or_horizontal == "horizontal") {
    // console.log('horizontal')

    for (let d = 0; d < X_bars; d++) {
      let marker;
      d === 0 ? (marker = "M") : (marker = "L");
      x_increment = x_increment + x;
      y_increment = parseInt(graph_flip(y * (data[d] / unitX)));

      if (d === 0) {
        firstPoint = `cx="${x_increment}" cy="${y_increment}"`;
      }

      // If its the first point put M if not put L
      svgPath += `${marker}${x_increment} ${y_increment} `;
    }
  } else if (vertical_or_horizontal == "vertical") {
    y = graphWidth / X_bars;
    x = graphHeight / Y_bars;
    x_increment = 0;
    y_increment = (x - x / 2) * -1; // offset the first item by half of itself, negatively. (0-y)

    for (let d = 0; d < X_bars; d++) {
      let marker;
      d === 0 ? (marker = "M") : (marker = "L");

      x_increment = parseInt(x * (data[d] / unitY)); //.toFixed(2))
      y_increment = parseInt(y_increment + y); //.toFixed(2))

      // If its the first point put M if not put L
      svgPath += `${marker}${x_increment} ${y_increment} `;
    }
  }

  return { first_point: firstPoint, line: svgPath };
}

export function createMoodLine(moodArray, graphWidth, graphHeight) {
  // make the SVG mood -line graphic

  // go through the MoodArray, and print each value out into the right spot
  // Y axis is the moodLevel
  // X axis is the hour, time, and graph increment size
  if (moodArray == undefined) {
    return;
  }
  let moodTimes = Object.entries(moodArray);
  let svgPath_d_moodLine = "";

  let x = graphWidth / window.ui.dayLength;
  for (let m = 0; m < moodTimes.length; m++) {
    let moodLevel = Math.abs(moodTimes[m][1] * 10 - 90); // SVG coordinates are backwards so we invert it...

    let hour = parseInt(moodTimes[m][0].match(/\d\d/));
    if (hour <= window.ui.dayStartTime) {
      hour += 24;
    } // so entries past midnight work
    hour = hour -= window.ui.dayStartTime; // offset it

    let mins = parseInt(String(moodTimes[m][0].match(/:\d\d/)).replace(":", ""));
    mins = mins * (x / 60);
    hour = hour * x;

    let increment = (hour + mins).toFixed(2);
    // console.log(x)
    // console.log(hour)
    // console.log(mins)
    // console.log(increment)

    // If its the first point put M if not put L
    let marker;
    m == 0 ? (marker = "M") : (marker = "L");
    svgPath_d_moodLine += `${marker}${increment} ${moodLevel} `;
  }
  return svgPath_d_moodLine;
}
